import * as React from 'react';
import $ from "jquery";
import Common from '../utilities/common';
import { Alert, Autocomplete, Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, InputLabel, ListItemText, MenuItem, Select, SelectChangeEvent, TextField, Typography } from '@mui/material';
import { MunicipioVariacion } from './MunicipioVariacion';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import { Provincia } from '../Provincias/Provincia';
import { Municipio } from '../Municipios/Municipio';
import ErrorDialog from '../utilities/ErrorDialog';

export interface IMunicipioVariacionNewProps {
    open: boolean;
    onClose?: Function;
    onSave?: Function;
}

export interface IMunicipioVariacionNewState {
    open: boolean;
    hasErrors: boolean;
    errorMessage: string;
    municipios: Municipio[];
    openErroDialog: boolean;
}

export default class MunicipioVariacionNew extends React.Component<IMunicipioVariacionNewProps, IMunicipioVariacionNewState> {
    _municipioVariacion: MunicipioVariacion = new MunicipioVariacion();
    
    public constructor(props: IMunicipioVariacionNewProps) {
        super(props);

        this.state = {
            open: false,
            hasErrors: false,
            errorMessage: '',
            municipios: [],
            openErroDialog: false
        }
    }

    componentDidMount(): void {
        this.GetMunicipios();
    }

    componentWillReceiveProps(nextProps: Readonly<IMunicipioVariacionNewProps>, nextContext: any): void {
        this.setState({
            open: nextProps.open
        });
    }

    public render(): React.ReactElement<{}> {
        return (
            <React.Fragment>
                <Dialog open={this.state.open} fullWidth>
                    <DialogTitle>
                        Nuevo municipio
                    </DialogTitle>
                    <DialogContent>
                        {
                            this.state.hasErrors && (
                                <Alert severity="error" style={{marginBottom: '10px'}}>
                                    {
                                        this.state.errorMessage
                                    }
                                </Alert>
                            )
                        }
                        <Box>
                            <Autocomplete
                                renderInput={(params) => (
                                    <TextField {...params} label="Seleccione un municipio" variant="standard" />
                                )}
                                onChange={(event: any, newValue: Municipio | null) => {
                                    this._municipioVariacion.municipio = newValue?.nombre;
                                }}
                                options={this.state.municipios}
                                getOptionLabel={(option: Municipio) => option.nombre!}
                                renderOption={(props, item) => (
                                    <li {...props} key={item.id}>
                                    <ListItemText>{item.nombre}</ListItemText>
                                    </li>
                                )}
                            />
                            <FormControl fullWidth style={{marginBottom: '20px'}}>
                                <TextField required variant='standard' label='Nombre' onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    if(event.target.value == '') {
                                        this.setState(
                                            {
                                                hasErrors: true,
                                                errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios o seleccione un archivo.'
                                            }
                                        );
                                    }
                                    else {
                                        this.setState(
                                            {
                                                hasErrors: false,
                                                errorMessage: ''
                                            }
                                        );
                                        this._municipioVariacion.variacion = event.target.value;
                                    }
                                }}></TextField>
                            </FormControl>
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.Save.bind(this)}>OK</Button>
                        <Button onClick={this.Close.bind(this)}>Cancelar</Button>
                    </DialogActions>
                </Dialog>
                <ErrorDialog open={this.state.openErroDialog} onClose={this.Close.bind(this)} />
            </React.Fragment>
        )
    }

    private Close() {
        this.setState(
            {
                open: false,
                openErroDialog: false,
                hasErrors: false,
                errorMessage: ''
            }
        );

        if(this.props.onClose != null) {
            this.props.onClose();
        }
    }

    private Save() {
        if (this._municipioVariacion.variacion == '' || 
            this._municipioVariacion.variacion == null ||
            this._municipioVariacion.municipio == '' || 
            this._municipioVariacion.municipio == null
        ) {
            this.setState({
                hasErrors: true,
                errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios o seleccione un archivo.'
            })
            return;
        }

        let url = `${Common.END_POINT}/masters/municipiosvariaciones`;
        $.ajax((
            {
                url: url,
                type: "POST",
                data: JSON.stringify(this._municipioVariacion),
                dataType: "json",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done(() => {
            if(this.props.onSave != null) {
                this.props.onSave();
            }

            this._municipioVariacion = new MunicipioVariacion();
        }).fail((jqXHR, textStatus, errorThrown) => {
            this.setState(
                {
                    open: false,
                    openErroDialog: true
                }
            );
    
            if(this.props.onSave != null) {
                this.props.onSave();
            }

            this._municipioVariacion = new MunicipioVariacion();
        });
    }

    private GetMunicipios(): void {
        let url = `${Common.END_POINT}/masters/municipios`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            console.log(response);
            this.setState(
                {
                    municipios: response
                }
            );
        })
    }
}